export default {
  "content": "<path d=\"M12 17a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM9 14.806v2.196l-1.243-1.243c.37-.37.788-.69 1.243-.953zM15 14.806c.455.263.873.583 1.242.952L15 17v-2.194zM13 15h-2V4.5h2V15zM9 10.458v2.126a8.004 8.004 0 00-2.658 1.76L4.928 12.93A9.996 9.996 0 019 10.458zM15 10.459a9.995 9.995 0 014.071 2.47l-1.414 1.414A8.006 8.006 0 0015 12.584v-2.125zM9 6.323V8.38a11.985 11.985 0 00-5.486 3.137L2.1 10.102A13.975 13.975 0 019 6.323zM15 6.325c.338.074.672.16 1 .257v2.105c-.327-.116-.66-.216-1-.304V6.325zM21.46 11c0-2.31.371-3.96 2.191-5.75V3.82h-5.3v1.43h3.59c-1.53 1.55-2.18 3.33-2.18 5.75h1.7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};